import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {SortingOrders} from "../../enums";
import {TSortDirection} from "../../types";


@Component({
  selector: 'int-sort-icon',
  templateUrl: 'int-sort-icon.component.html',
  styleUrls: ['int-sort-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntSortIconComponent {

  @Input() order: TSortDirection | null = SortingOrders.ASC;

  get isAsc() {
    return this.order === SortingOrders.ASC
  }

  get isDesc() {
    return this.order === SortingOrders.DESC
  }
}
